import React, { useEffect, useContext, useState} from 'react';

import AppContext from '../hooks/AppContext'

import MainPage from '../_template/MainPage'

import ListaCandidatos from '../components/ListaCandidatos'

const Votacao = (props) => {
    
  const { mock, instanciaInfo, setInstancia, setLoading, 
    totalizacao, cargos, localidades, ufs, 
    rolagemAuto, ordenaPorVoto, 
    setLocalidadeSelecionadaId, setCargoSelecionadoId,
    localidadeSelecionada, cargoSelecionado } = useContext(AppContext);  

  //Desativa o loading ao carregar os dados básicos da tela
  useEffect(()=>{ 
    if(cargos?.length>0 && localidades?.length>0 && ufs?.length>0 && instanciaInfo && instanciaInfo?.onLine!=false){
      setLoading(false)
    }
    
    //define configuração de início para uf e primiero cargo da lista    
    /*if(!localidadeSelecionada){
      if(ufs?.length>0){
        setLocalidadeSelecionadaId(ufs[0]?.sgUe)
      }
    }*/
    /*if(!localidadeSelecionada && !cargoSelecionado){
      if(cargos?.length>0){        
        setCargoSelecionadoId(cargos[0]?.codigo)
      }
      if(ufs?.length>0){
        setLocalidadeSelecionadaId(ufs[0]?.sgUe)
      }      
    } */   

  },[cargos, localidades, ufs, instanciaInfo])

  const leftTitle = ()=>{
    if(totalizacao){
      return totalizacao?.cargo?.nomeNeutro || "Candidatos"
    }
    return "Candidatos"
  }

  const filtroTitle = ()=>{    
    let pleitoNome = instanciaInfo?.pleito?.nome?.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")  
    let title="Configuração"

    if(instanciaInfo?.processoEleitoral?.nome){
      title=instanciaInfo?.processoEleitoral?.nome
    }

    if(!pleitoNome?.includes("unico") && instanciaInfo?.pleito?.nome){     
      title = title + " "+ instanciaInfo?.pleito?.nome      
    }    

    return title
  }

  return (      
    <MainPage titulo={leftTitle()}
      renderFiltro filtroCargo filtroTitulo={filtroTitle()}                  
      resumoTitulo="Votação"
      renderVotos={totalizacao}>

      <ListaCandidatos ordenaPorVoto={ordenaPorVoto}/>

    </MainPage>
  );
}

export default Votacao;
